import React from 'react';
import {
  Box,
  Icon,
  Icons,
  styled,
  Tooltip,
  Typography,
} from '@nextiva/next-ui-components';

export const HeaderTypo = (props) => {
  return <Typography variant="h6" color="#0B1029" {...props} />;
};

export const SubtitleTypo = (props) => {
  return (
    <Typography
      variant="subtitle2"
      color="#0B1029"
      sx={{ display: 'flex', alignItems: 'center' }}
      {...props}
    />
  );
};

export const Subtitle3Typo = (props) => {
  return <Typography variant="subtitle3" color="#55596B" {...props} />;
};

export const OverlineTypo = (props) => {
  return <Typography variant="overline" color="#54687F" {...props} />;
};

export const Body2Typo = (props) => {
  return <Typography variant="body2" color="#55596B" {...props} />;
};

export const StyledLinkBox = styled(Box)`
  & a {
    color: ${({ theme }) => theme.palette.primary.main};
  }
`;

export function HelpTooltip({
  dataTestId,
  title,
}: {
  dataTestId: string;
  title: string;
}) {
  return (
    <Tooltip data-testid={dataTestId} title={title} placement="right-end">
      <Icon icon={Icons.help} sx={{ fontSize: '12px', marginLeft: '8px' }} />
    </Tooltip>
  );
}
